import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Property } from '../../models/property';
import { RentableItem } from '../../models/rentableitem';
import { EventEmitterService } from 'services/event-emitter.service';
import { SplashService } from 'services/splash.service';
import { ApplicationDataService } from '../../../services/application.service';
import { RentablesDataService } from '../../../services/rentables.service';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatDialog, MatDialogConfig} from "@angular/material/dialog";
import { AnalyticsService } from 'services/analytics.service';
import { RentableItemTestDiaglogComponent } from './rentable-item-test-diaglog/rentable-item-test-diaglog.component';
import { AmenityType } from "enumerations/amenity-type";
import { AncillaryItemsDataService } from '../../../services/ancillary-items.service';
import { AncillaryItemViewModel } from 'app/models/AncillaryItemViewModel';
import { AncillaryItemGridItem } from 'app/models/ancillary-item-grid-item';
import { Observable } from 'rxjs';
import { TooltipPosition } from '@ng-matero/extensions/tooltip/tooltip';
import { AncillaryItemDescriptionViewModel } from 'app/models/AncillaryItemDescriptionViewModel';

@Component({
  selector: 'app-rentables',
  templateUrl: './rentables.component.html',
  styleUrls: ['./rentables.component.css']
})
export class RentablesComponent implements OnInit {
  rentalApplicationKey: number;
  rentalApplicantKey: number;
  modelProperty: Property;
  splashHTML: string;
  errorMessage: string;
  rentablesCost: number = 0;
  aniCost: number = 0;
  rentableItems: RentableItem[] = [];
  AncillaryItems: AncillaryItemGridItem[] = [];
  primaryApplicant: boolean = false;
  totalApplicationSteps: number = 9;
  updateTestRentableItems:boolean = false;
  yardiKey: string;
  currentApplicationStep: number = 8;
  verifastEnabled: boolean;
  serviceFees: number = 0;
  showServiceFees: boolean = false;
  serviceFeesToolTip = "";
  selectedServiceFee:boolean = true;
  isLoading:boolean = true;
  positionOptions: TooltipPosition[] = ['after', 'before', 'above', 'below', 'left', 'right'];
  position = this.positionOptions[4];

  constructor(
    public dialog: MatDialog,
    private router: Router,
    private eventEmitterService: EventEmitterService,
    private splashService: SplashService,
    private applicationService: ApplicationDataService,
    private rentablesService: RentablesDataService,
    private ancillaryItemsDataService: AncillaryItemsDataService,
    private readonly analyticsService: AnalyticsService) {
    const correctStatus = localStorage.getItem('CorrectStatus');
    const rentalApplicationKey = localStorage.getItem('RentalApplicationKey');
    const rentalApplicantKey = localStorage.getItem('RentalApplicantKey');
    const primaryApplicant = localStorage.getItem('PrimaryApplicant');
    this.yardiKey = localStorage.getItem('YardiKey');

    if(primaryApplicant == "true") {
      this.primaryApplicant = true;
    }

    if (correctStatus != "true") {
      localStorage.removeItem('RentalApplicationKey');
      this.analyticsService.track(
        'HRA Application',
        'Rentables',
        'Stop',
        'Application not in the correct status',
        '/application/dashboard',
        this.additionalAnalyticsDetails());
      this.router.navigate(['/application/dashboard']);
    }

    this.eventEmitterService.splashChangeEmitted$.subscribe(res => this.updateSplashHTML(res));
    this.splashService.updateSplash("apply");

    if (rentalApplicantKey !== undefined && rentalApplicantKey !== null && rentalApplicationKey !== undefined && rentalApplicationKey !== null) {
      this.rentalApplicationKey = Number(rentalApplicationKey);
      this.rentalApplicantKey = Number(rentalApplicantKey);

      this.rentablesService.GetRentableItems(rentalApplicationKey)
        .subscribe(res => this.onGetRentableItemsSuccess(res), res => this.errorMessage = this.applicationService.handleError(res));

      if (this.primaryApplicant) {
        this.ancillaryItemsDataService.SyncAncillaryItems(
          this.rentalApplicationKey)
          .subscribe(
            _ => this.LoadAncillaryItems(),
            res => this.errorMessage = this.applicationService.handleError(res));
      } else {
        this.LoadAncillaryItems()
      }

    }
  }

  private additionalAnalyticsDetails(): any {
    try {
      let mixPanelObj = {
        Type: [],
        Cost: [],
        Description: [],
        Notes: [],
        TestItem: [],
        IsSelected: []
      }
      this.rentableItems
        ?.forEach(x =>{
            mixPanelObj.Type.push(x.Type)
            mixPanelObj.Cost.push(x.Cost)
            mixPanelObj.Description.push(x.Description)
            mixPanelObj.Notes.push(x.Notes)
            mixPanelObj.TestItem.push(x.IsTestableItem)
            mixPanelObj.IsSelected.push(x.IsSelected)
          });

      return mixPanelObj;
    } catch (error) {
      return {};
    }
  }

  private CreatMixPanelObject(item: RentableItem, selected: boolean): any {
    try {
      return {
        'Type': [item.Type],
        'Cost': [item.Cost],
        'Description': [item.Description],
        'Notes': [item.Notes],
        'TestItem': [item.IsTestableItem],
        'IsSelected': [selected]
      };
    } catch (error) {
      return {};
    }
  }

  private CreatMixPanelAncillaryItemObject(item: AncillaryItemGridItem, selected: boolean): any {
    try {
      return {
        'Type': [item.Name],
        'Cost': [item.Cost],
        'Description': [item.Description],
        'Notes': [''],
        'TestItem': [false],
        'IsSelected': [selected]
      };
    } catch (error) {
      return {};
    }
  }

  ngOnInit() {
    const verifastEnabled = localStorage.getItem('verifastEnabled');
    if (verifastEnabled && verifastEnabled === 'true') {
      this.verifastEnabled = true;
      this.totalApplicationSteps++;
      this.currentApplicationStep++;
    }

    const property = JSON.parse(localStorage.getItem('SelectedProperty'));
    if (property != null) {
      this.modelProperty = property[0];
      if ((property[0].min_rent != null && property[0].max_rent != null) && (property[0].min_rent == property[0].max_rent)) {
        this.modelProperty.rent = property[0].min_rent.toLocaleString();
      }
      else if (property[0].min_rent != null && property[0].max_rent != null) {
        this.modelProperty.rent = property[0].min_rent.toLocaleString() + '-$' + property[0].max_rent.toLocaleString()
      }
    }
  }

  updateSplashHTML(res: string) {
    this.splashHTML = res;
  }

  LoadAncillaryItems() {
    this.ancillaryItemsDataService.GetAllAncillaryItemForApplication(
      this.rentalApplicationKey)
      .subscribe(
        res => this.HandelAncillaryItems(res),
        res => this.errorMessage = this.applicationService.handleError(res));
  }

  HandelAncillaryItems(ancillaryItemViewModels: AncillaryItemViewModel[]) {
    let data = [];
    let cost = 0;
    for (var i = 0; i < ancillaryItemViewModels.length; i++) {
      var ancillaryItem = new AncillaryItemGridItem(
        ancillaryItemViewModels[i].ItemKey,
        ancillaryItemViewModels[i].IsSelected,
        ancillaryItemViewModels[i].IsRequired,
        ancillaryItemViewModels[i].IsRequired || !this.primaryApplicant,
        ancillaryItemViewModels[i].IsGroup,
        ancillaryItemViewModels[i].Cost,
        ancillaryItemViewModels[i].Name,
        ancillaryItemViewModels[i].Description,
        ancillaryItemViewModels[i].Descriptions);
      if (ancillaryItem.Descriptions != null) {
        ancillaryItem.Description = this.genAniDescriptionTable(ancillaryItem.Descriptions, ancillaryItem.Description)
      }
      data.push(ancillaryItem);
      if (ancillaryItem.Cost > 0 && ancillaryItem.IsSelected) {
        cost += ancillaryItem.Cost;
      }
    }
    this.aniCost = cost;
    this.AncillaryItems = data;
    this.isLoading = false;

    this.analyticsService.track(
      'HRA Application',
      'AncillaryItems',
      'Start',
      'Start',
      '',
      this.additionalAnalyticsDetails());
  }

  genAniDescriptionTable(anis: AncillaryItemDescriptionViewModel[], groupName: string) {
    var table = `<table><tr><th colspan=2>${groupName}</th></tr>`
    for (const ani of anis) {
      table += `<tr><td>${ani.Name}</td><td>${ani.Description}</td></tr>`
    }
    table += `</table>`;
    return table;
  }

  onGetRentableItemsSuccess(rentableItems: RentableItem[] | undefined | null) {
    if (!rentableItems) {
      this.serviceFees = 0;
      this.showServiceFees = false;
      return;
    }
    for (const rentableItem of rentableItems) {
      rentableItem.showLineItem = rentableItem.AmenityType != AmenityType.Service;
      if (!isNaN(rentableItem.Cost)) {
        this.rentablesCost = rentableItem.IsSelected ? this.rentablesCost + Number(rentableItem.Cost) : this.rentablesCost;
      }
    }

    this.serviceFees = rentableItems.filter(x => x.AmenityType == AmenityType.Service).reduce((acc, item) => acc + Number(item.Cost), 0);
    this.showServiceFees = this.serviceFees > 0;
    this.serviceFeesToolTip = rentableItems.filter(x => x.AmenityType == AmenityType.Service).map(x => ` ${x.Type}`).toString();

    this.rentableItems = rentableItems;

    this.analyticsService.track(
      'HRA Application',
      'Rentables',
      'Start',
      'Start',
      '',
      this.additionalAnalyticsDetails());
  }

  onRentableItemChange(ob: MatCheckboxChange, item: RentableItem) {
    if (ob.checked) {
      this.rentablesCost += Number(item.Cost);
    }
    else {
      this.rentablesCost -= Number(item.Cost);
    }
    this.analyticsService.track(
      'HRA Application',
      'Rentables',
      'Item Select',
      'Item Selected',
      '',
      this.CreatMixPanelObject(item, ob.checked));
  }

  onAncillaryItemChange(ob: MatCheckboxChange, item: AncillaryItemGridItem) {
    this.isLoading = true;
    var action: Observable<string | Object>;
    if (ob.checked) {
      this.aniCost += Number(item.Cost);
      if (item.IsGroup) {
        action = this.ancillaryItemsDataService.AddAncillaryItemGroup(
          this.rentalApplicationKey,
          item.ItemKey);
      } else{
        action = this.ancillaryItemsDataService.AddAncillaryItem(
          this.rentalApplicationKey,
          item.ItemKey);
      }
    }
    else {
      this.aniCost -= Number(item.Cost);
      if (item.IsGroup) {
        action = this.ancillaryItemsDataService.RemoveAncillaryItemGroup(
          this.rentalApplicationKey,
          item.ItemKey);
      } else{
        action = this.ancillaryItemsDataService.RemoveAncillaryItem(
          this.rentalApplicationKey,
          item.ItemKey);
      }
    }

    this.analyticsService.track(
      'AncillaryItems',
      'Stop',
      'Item Select',
      'Item Selected',
      '',
      this.CreatMixPanelAncillaryItemObject(item, ob.checked));
    action
      .subscribe(
        _ => this.LoadAncillaryItems(),
        res => this.errorMessage = this.applicationService.handleError(res));
  }

  disableTestableItems = () => {
    this.rentableItems.forEach(element => {
      if(element.IsSelected && element.IsTestableItem){
        element.IsSelected = false;
        element.DisableTestableItem = true;
        this.rentablesCost -= Number(element.Cost);
      }
    });
  }

  onSubmit() {
    this.rentableItems;
    var testItemName;
    this.rentableItems.forEach(element => {
      if(element.IsSelected && element.IsTestableItem && !element.DisableTestableItem){
        this.updateTestRentableItems = true;
        testItemName = element.Type;
      }
    });

    if(this.updateTestRentableItems){
      const dialogConfig = new MatDialogConfig();
      dialogConfig.width = "300px";
      dialogConfig.data = {
        amenityName: testItemName
      }

      this.disableTestableItems();
      this.dialog.open(RentableItemTestDiaglogComponent, dialogConfig);
      this.updateTestRentableItems = false;
      return;
    }

    if (this.AncillaryItems.length > 0 && this.primaryApplicant) {
      this.analyticsService.track(
        'HRA Application',
        'AncillaryItems',
        'Stop',
        'ANIs saved',
        '',
        this.additionalAnalyticsDetails());
    }

    this.submitRentables();
  }

  private submitRentables() {
    if (this.rentableItems) {
      this.rentablesService.UpdateRentableItems(
        this.rentalApplicantKey,
        this.rentalApplicationKey,
        this.rentableItems)
        .subscribe(
          _ => this.onUpdateSuccess(),
          res => this.errorMessage = this.applicationService.handleError(res));
    } else {
      this.onUpdateSuccess();
    }
  }

  onUpdateSuccess() {
    if (this.primaryApplicant) {
      this.analyticsService.track(
        'HRA Application',
        'Rentables',
        'Stop',
        'Sending to payment',
        '/application/payment',
        this.additionalAnalyticsDetails());
      this.router.navigate(['/application/payment']);
    } else {
      this.analyticsService.track(
        'HRA Application',
        'Rentables',
        'Stop',
        'Sending to dashboard',
        '/application/dashboard',
        this.additionalAnalyticsDetails());
      this.router.navigate(['/application/dashboard', 'background']);
    }
  }

  // Do Not Delete.  ngFor will break on add remove without.
  listTrack(o) {
    return o;
  }
}
